export const chooseDeclension = (count: number, one = `штука`, three = `штуки`, five = `штук`): string => {
    count %= 100;

    if (count >= 11 && count <= 19) {
        return five;
    }

    count %= 10;

    if (count === 1) {
        return one;
    }

    if (count > 0 && count <= 4) {
        return three;
    }

    return five;
};

export const readableFileSize = (size: number): string => {
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

    return `${+(size / Math.pow(1024, i)).toFixed(2)} ${[`B`, `kB`, `MB`, `GB`, `TB`][i]}`;
};
